import * as $ from 'jquery';
import * as formValidation from "../modules/formValidation";

declare const grecaptcha: any;

namespace KWS.controllers.registerProduct {

	let $form = $('form');
    let $divRegisterForm = $('#divRegisterForm');
	let $alertSuccess = $('.js-alert-success');
	let $alertDanger = $('.js-alert-danger');
	let $alertDangerFields = $('.js-alert-danger-fields');
	let $errorList = $('.js-issues-need-correction');
	let $firstName = $('#first-name');
	let $lastName = $('#last-name');
	let $email = $('#email');
	let $address = $('#address');
	let $address2 = $('#address2');
	let $country = $('#country');
	let $city = $('#city');
    //let $stateProvince = $('#state');
    let $state = $('#state');
    let $province = $('#province');
	let $postalCode = $('#postal-code');
	let $phone = $('#phone');
	let $upc = $('#upcCode');
	let $datePurchased = $('#date-purchased');
	let $purchaseLocation = $('#purchase-location');
    let $uploadDocument = $('#uploadPhoto');
	let $submit = $('#submit');    
    let $divLoader = $('#divLoading');
    let $uploadDocumentRequired = "Proof of purchase has to be uploaded";

	//patternChecks
	let zipcodePattern = /^(\d{5}(-\d{4})?|[A-Z]\d[A-Z] ?\d[A-Z]\d)$/;
	let datePattern = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;

	let constraints = {
		'first-name': {
			presence: {
				allowEmpty: false,
				message: '^' + 'First Name cannot be blank'
			}
		},
		'last-name': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Last Name cannot be blank'
			}
		},
		email: {
			presence: {
				allowEmpty: false,
				message: '^' + 'Email cannot be blank'
			},
			email: {
				message: '^' + 'Email is not valid'
			}
		},		
		address: {
			presence: {
				allowEmpty: false,
				message: '^' + 'Street Address cannot be blank'
			}
		},
		address2: {
			presence: false
		},
		country: {
			presence: {
				allowEmpty: false,
				message: '^' + 'Country cannot be blank'
			}
		},
		city: {
			presence: {
				allowEmpty: false,
                message: '^' + 'City cannot be blank'
			}
		},
		'state': {
			presence: {
				allowEmpty: false,
				message: '^' + 'State/Province cannot be blank'
			}
        },        
		'postal-code': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Postal code cannot be blank'
			},
			format: {
				pattern: zipcodePattern,
				message: '^' + 'Postal code is not valid'
			}
		},
		phone: {
			presence: {
				allowEmpty: false,
				message: '^' + 'Phone cannot be blank'
			}
		},
		upc: {
			presence: {
				allowEmpty: false,
				message: '^' + 'UPC cannot be blank'
			}
		},
		'date-purchased': {
			presence: {
				allowEmpty: false,
				message:'^' + 'Purchase Date cannot be blank'
			},
			format: {
				pattern: datePattern,
				message:'^' + 'Purchase Date is invalid'
			},
			datetime: {
				dateOnly: true,
				latest: Date.now(),
				message:'^' + 'Purchase Date cannot be in future'
			}

		},
		'purchase-location': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Purchase Location cannot be blank'
			}
		},
		'recaptcha-token': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Captcha is Required'
			}
		}
	};

    let formatDate = function (date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    $country.change(function () {
        if ($(this).val() == "CAN") {
            $("#divprovince").show();
            $("#divstate").hide();
        }
        else {
            $("#divprovince").hide();
            $("#divstate").show();
        }
    });
    //let onChangeCountry = function (obj) {        
    //    if ($(obj).val() == "CAN") {
    //        $("#divprovince").show();
    //        $("#divstate").hide();
    //    }
    //    else {
    //        $("#divprovince").hide();
    //        $("#divstate").show();
    //    }
    //};

    let validateField = function () {        
		$(this).addClass('dirty');
        if (formValidation.validateWrapper({
            constraints: constraints,
            values: {
                'first-name': $firstName.val(),
                'last-name': $lastName.val(),
                email: $email.val(),
                address: $address.val(),
                address2: $address2.val(),
                country: $country.val(),
                city: $city.val(),
                'state': $state.val(),
                'province': $province.val(),
                'postal-code': $postalCode.val(),
                phone: $phone.val(),
                upc: $upc.val(),
                'date-purchased': formatDate($datePurchased.val()),
                'purchase-location': $purchaseLocation.val(),
                'recaptcha-token': grecaptcha.getResponse()
            }
        })) {
            return false;
        }
        else
            return true;
	};

    let setupHandlers = function () {	
        $('body').on('click', '.js-reset-file', function (e) {
            let fileInput = $(this).parents('.aaq-file-input').find('input[type=file]');
            fileInput.val(null);
            fileInput.siblings('.js-file-input-value').html('');
            fileInput.trigger('change');
            fileInput.trigger('blur');
            e.preventDefault();
        });
		$('#uploadPhoto').on('change.upload', function(){
				var $value = $(this).siblings('.js-file-input-value');
				var $this = $(this);
				if ( this.files && this.files[0] ) {
					if($this.data("accept")) {
						let fileAssocArray = $this.data("accept").split(',');
						let fileName = this.files[0].name;
						let fileExt = fileName.split(/[. ]+/).pop();
						if(fileAssocArray.indexOf(`.${fileExt}`) > -1) {
							$value.html( this.files[0].name );
                           $value.append('<i class="icon icon-close aaq-file-input-close js-reset-file" title="Remove Image"></i>')
							validateField();
						} else {
							alert(`.${fileExt} files are not allowed. Please choose one of the following file types: (${fileAssocArray})`);
						}
					} else {
						$value.html( this.files[0].name );
                        $value.append('<i class="icon icon-close aaq-file-input-close js-reset-file" title="Remove Image" click=></i>');
						validateField();
					}
				} else {
					$value.html('');
					validateField();
				}
			});       
    };    

	
	let trackRegisterProductSubmit = function () {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event' : 'register_a_product_submitted'
		});
		console.log(window.dataLayer);
	};


	let inputEventListeners = function () {
		$firstName.on('blur change', validateField);
		$lastName.on('blur change', validateField);
		$email.on('blur change', validateField);		
		$address.on('blur change', validateField);
		$address2.on('blur change', validateField);
		$country.on('blur change', validateField);
		$city.on('blur change', validateField);        
        if ($country.val() == "CAN") {
            $province.on('blur change', validateField);
        }
        else {
            $state.on('blur change', validateField);
        }
		$postalCode.on('blur change', validateField);
		$phone.on('blur change', validateField);
		$upc.on('blur change', validateField);
		//$datePurchased.on('blur change', validateField);
		$purchaseLocation.on('blur change', validateField);
		grecaptcha.ready(() => {
			grecaptcha.render( document.getElementById('g-recaptcha'), {
				callback: validateField
			});
		});
    };
           
    let submitEventListener = function () {
        $submit.on('click', function (e) {
            e.preventDefault();                     
            $divLoader.removeClass('hidden');
            $divRegisterForm.addClass('hidden');
            $('.js-alert').addClass('hidden');
            window.scrollTo(0, 0);
            let $fileHasValue = $uploadDocument.val() != "";  
            let stateProvince = $state.val()
            if ($country.val() == "CAN") {
                stateProvince = $province.val();
            }
            if (formValidation.validateWrapperSubmit({
                constraints: constraints,
                values: {
                    'first-name': $firstName.val(),
                    'last-name': $lastName.val(),
                    email: $email.val(),                   
                    address: $address.val(),
                    address2: $address2.val(),
                    country: $country.val(),
                    city: $city.val(),
                    'state': stateProvince,
                    'postal-code': $postalCode.val(),
                    phone: $phone.val(),
                    upc: $upc.val(),
                    'date-purchased': formatDate($datePurchased.val()),
                    'purchase-location': $purchaseLocation.val(),
                    'recaptcha-token': grecaptcha.getResponse()
                }
            }) && $fileHasValue === true) {
                // check form
            } else {
                if ($fileHasValue === false) {
                    $(`<li>${$uploadDocumentRequired}</li>`).appendTo($errorList);
                }
                $alertDangerFields.removeClass('hidden');
                $("html, body").animate({ scrollTop: 0 }, 500);
                $divRegisterForm.removeClass('hidden');               
                $divLoader.addClass('hidden'); 
                return;
            }

            $.get("/api/kwiksetsupport/validateupc?upc=" + $upc.val())
                .done(function (result) {
                    if (result) {
                        let data = new FormData();
                        let stateProvince = $state.val()
                        if ($country.val() == "CAN") {
                            stateProvince = $province.val();
                        }
                        let contactInfo = JSON.stringify({
                            FirstName: $firstName.val(),
                            LastName: $lastName.val(),
                            Email: $email.val(),
                            Address1: $address.val(),
                            Address2: $address2.val(),
                            Country: $country.val(),
                            City: $city.val(),
                            State: stateProvince,
                            PostalCode: $postalCode.val(),
                            Phone: $phone.val()
                        });

                        let product = JSON.stringify({
                            UpcCode: $upc.val(),
                            DatePurchased: formatDate($datePurchased.val()),
                            PurchaseLocation: $purchaseLocation.val()
                        });

                        data.append("ContactInfo", contactInfo);
                        data.append("Product", product);
                        data.append("File", (<HTMLInputElement>document.getElementById('uploadPhoto')).files[0]);

                        $.ajax({
                            url: '/api/kwiksetsupport/registerproduct',
                            type: 'POST',
                            dataType: 'json',
                            data: data,
                            processData: false,
                            contentType: false
                        })
                            .done(function () {
                                $alertSuccess.removeClass('hidden');                               
                                formValidation.resetForm($form);                               
                                grecaptcha.reset();
                                $('.js-file-input-value').text('');
                                trackRegisterProductSubmit();
                            })
                            .fail(function (response) {
                                $alertDanger.removeClass('hidden').find('.alert__text');
                            })
                            .always(function () {
                                window.scrollTo(0, 0);
                                $divRegisterForm.removeClass('hidden');                               
                                $divLoader.addClass('hidden'); 
                            });
                    } else {
                        let upcNotValid = 'FormValidationErrors.UPCCodeNotValid';
                        $alertDanger
                            .removeClass('hidden')
                            .find('.js-alert-text')
                            .text(upcNotValid);

                        window.scrollTo(0, 0);
                        $divRegisterForm.removeClass('hidden');                       
                        $divLoader.addClass('hidden'); 
                    }
                })
                .fail(function (response) {
                    $alertDanger
                        .removeClass('hidden')
                        .find('.js-alert-text');
                    window.scrollTo(0, 0);
                    $divRegisterForm.removeClass('hidden');                    
                    $divLoader.addClass('hidden');                    
                });
        });
    };
	

	export function init() {
		setupHandlers();		
		inputEventListeners();
        submitEventListener();		
	}
}
KWS.controllers.registerProduct.init();
